import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { OpenIdConfiguration } from 'src/app/services/auth/auth-config';

const configure: OpenIdConfiguration = {
  authority: environment.authentication.issuer,
  clientId: 'Lcp.Monarch.Client',
  forbiddenRoute: '/not-authorized',
  // logLevel: LogLevel.Error,
  postLogoutRedirectUri: environment.authentication.postLogoutRedirectUri,
  redirectUrl: environment.authentication.redirectUrl,
  responseType: environment.authentication.responseType,
  scope: environment.authentication.scope, // 'openid profile offline_access ' + your scopes
  triggerAuthorizationResultEvent: true,
  unauthorizedRoute: '/not=authorized',
  useRefreshToken: true,
  silentRenew: true,
  //   silentRenewUrl: environment.authentication.silentRenewUrl,
  tokenRefreshInSeconds: 30,
  renewTimeBeforeTokenExpiresInSeconds: 300,
  silentRenewTimeoutInSeconds: 30,
};

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: configure,
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
